// import React from "react";
// import { useEffect } from "react";
// import { supabase } from "./supabase";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import SignUp from "./components/Authentication/SignUp";
// import Login from "./components/Authentication/Login";
// import ProjectForm from "./components/Projects/ProjectForm";
// import "./App.css"; // Import the CSS file
// import About2 from "./components/About&Contact/About2";
// import Privacy2 from "./components/About&Contact/Privacy2";
// import Contact from "./components/About&Contact/Contact";
// import { ReactComponent as ProfileIcon } from "./icons/profile-circle-svgrepo-com.svg";
// import Navbar3 from "./components/Navbar/Navbar3";
// import Navbar2 from "./components/Navbar/Navbar2";

// import ProfileForm from "./components/Profiles/ProfileForm";
// import UserProfile from "./components/Profiles/UserProfile";
// import ProfileEdit from "./components/Profiles/ProfileEdit";
// import Account from "./components/Account/Account";
// import HomePage from "./components/LandingPage/HomePage";

// import NominationPage from "./components/Nominate/NominationPage";

// import Messages from "./components/Messages/Messages";
// import Explore from "./components/PostSignIn/Explore";
// import NewBookings from "./components/Bookings/NewBookings";
// import SpeakerAvailability from "./components/Services/SpeakerAvailability";

// import SpeakerRegistrationForm from "./components/BecomeASpeaker/SpeakerRegistrationForm";
// import ServiceSelector from "./components/ServiceSelector";
// import TermsOfService from "./components/About&Contact/TermsOfService";
// import CollavoLanding from "./components/LandingPage/CollavoLanding";

// import Dashboard from "./components/Pages/Dashboard";
// import ProtectedRoute from "./components/ProtectedRoute";

// const App = () => {
//   useEffect(() => {
//     const fetchSession = async () => {
//       const {
//         data: { user },
//       } = await supabase.auth.getUser();

//       if (user) {
//         // Check if the user already has a profile, if not create one
//         const { data, error } = await supabase
//           .from("user_profiles")
//           .select("user_id")
//           .eq("user_id", user.id)
//           .single();

//         if (!data) {
//           // No profile exists, create one
//           const { error: insertError } = await supabase
//             .from("user_profiles")
//             .insert([{ user_id: user.id, full_name: user.email }]); // Replace with default profile data

//           if (insertError) {
//             console.error("Error creating profile:", insertError);
//           }
//         }
//       }
//     };

//     fetchSession();
//   }, []);
//   return (
//     <Router>
//       <div className="app-wrapper">
//         {/* <Navbar2 /> */}
//         <div className="main-content">
//           <Routes>
//             <Route path="/" element={<HomePage />} />
//             <Route path="/signup" element={<SignUp />} />
//             <Route path="/login" element={<Login />} />
//             <Route path="/request" element={<ProjectForm />} />
//             <Route path="/about_collavo" element={<About2 />} />
//             <Route path="/privacy" element={<Privacy2 />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/profile/:userId" element={<UserProfile />} />
//             <Route path="/edit-profile" element={<ProfileEdit />} />
//             {/* <Route path="/profileform" element={<ProfileForm />} />
//             <Route path="/account" element={<Account />} /> */}
//             <Route path="/mybookings" element={<NewBookings />} />
//             {/* <Route path="/nominations" element={<NominationPage />} />
//             <Route path="/nominate" element={<NominationPage />} />
//             <Route path="/nomination/:id" element={<NominationPage />} /> */}
//             <Route path="/messages" element={<Messages />} />
//             {/* <Route path="/explore" element={<Explore />} /> */}
//             {/* <Route path="/availability" element={<SpeakerAvailability />} /> */}
//             {/* <Route
//               path="/speakerregistrationform"
//               element={<SpeakerRegistrationForm />}
//             /> */}
//             <Route path="/explore" element={<Explore />} />
//             <Route path="/serviceselector" element={<ServiceSelector />} />
//             <Route path="/terms" element={<TermsOfService />} />
//             <Route path="/landing" element={<CollavoLanding />} />\
//             <Route path="/dashboard" element={<Dashboard />} />
//             <Route
//               path="/profile/setup"
//               element={
//                 <ProtectedRoute>
//                   <ServiceSelector />
//                 </ProtectedRoute>
//               }
//             />
//           </Routes>
//         </div>
//       </div>
//     </Router>
//   );
// };

// export default App;

import React, { useEffect } from "react";
import { supabase } from "./supabase";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import AuthCallback from "./components/Auth/AuthCallback";
import { DarkModeProvider } from "./contexts/DarkModeContext";

// Landing & Auth
import MobileLanding from "./components/MobileSignUp/orange";

// Service Provider Flow
import ServiceSelector from "./components/ServiceSelector";
import ServeToThrive from "./components/ServeToThrive/ServeToThrive";
import OnboardingMVP from "./components/OnboardingMVP";
import OnboardingFlow from "./components/Onboarding/OnboardingFlow";
import UserProfile from "./components/Profiles/UserProfile";

// Dashboard & Core Features
import Dashboard from "./components/Dashboard/Dashboard";
import Explore from "./components/PostSignIn/Explore";
import NewBookings from "./components/Bookings/NewBookings";
import Messages from "./components/Messages/Messages";
import Settings from "./components/Settings/Settings";
import SavedProfiles from "./components/SavedProfiles/SavedProfiles";

// Legal & Info
import About from "./components/About&Contact/About";
import PrivacyPolicy from "./components/About&Contact/PrivacyPolicy";
import Contact from "./components/About&Contact/Contact";
import TermsOfService from "./components/About&Contact/TermsOfService";

// Protected Route
import ProtectedRoute from "./components/ProtectedRoute";

// After completing SelectService form
import ProfileComplete from "./components/Pages/ProfileComplete";

// Reference Verification (public)
import ReferenceVerification from "./components/ReferenceVerification/ReferenceVerification";

const App = () => {
  useEffect(() => {
    const fetchSession = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (user) {
        // Check if the user already has a profile
        const { data, error } = await supabase
          .from("user_profiles")
          .select("user_id")
          .eq("user_id", user.id)
          .single();

        if (!data && !error) {
          // No profile exists, create one (backup in case trigger fails)
          const { error: insertError } = await supabase
            .from("user_profiles")
            .insert([
              {
                user_id: user.id,
                email: user.email,
                skill_provider: true,
                skill_active: false,
              },
            ]);

          if (insertError) {
            console.error("Error creating profile:", insertError);
          }
        }
      }
    };

    fetchSession();
  }, []);

  return (
    <DarkModeProvider>
      <Router>
        <div className="app-wrapper">
          <div className="main-content">
            <Routes>
            {/* Public Routes */}
            <Route path="/" element={<MobileLanding />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/contact" element={<Contact />} />
            {/* Public Profile View */}
            <Route path="/profile/:userId" element={<UserProfile />} />
            {/* Browse Providers (Public or Protected - your choice) */}
            <Route path="/explore" element={<Explore />} />
            {/* Protected Routes - Require Authentication */}
            <Route
              path="/profile/setup"
              element={
                <ProtectedRoute>
                  <ServeToThrive />
                </ProtectedRoute>
              }
            />
            {/* New Onboarding Flow */}
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <OnboardingFlow />
                </ProtectedRoute>
              }
            />
            {/* Legacy ServiceSelector route (kept for backwards compatibility) */}
            <Route
              path="/serviceselector"
              element={
                <ProtectedRoute>
                  <ServiceSelector />
                </ProtectedRoute>
              }
            />
            {/* MVP Testing Route - Simplified Onboarding */}
            <Route
              path="/onboarding-mvp"
              element={
                <ProtectedRoute>
                  <OnboardingMVP />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/bookings"
              element={
                <ProtectedRoute>
                  <NewBookings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/messages"
              element={
                <ProtectedRoute>
                  <Messages />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/saved"
              element={
                <ProtectedRoute>
                  <SavedProfiles />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route
              path="/profile-complete"
              element={
                <ProtectedRoute>
                  <ProfileComplete />
                </ProtectedRoute>
              }
            />

            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/verify-reference/:token" element={<ReferenceVerification />} />
          </Routes>
        </div>
      </div>
    </Router>
    </DarkModeProvider>
  );
};

export default App;
